import {z} from 'zod';
import {SearchTypesEnum} from './constants';

export const SearchResult = z.object({
  content: z.string(),
  postDate: z.string(),
  title: z.string(),
  type: SearchTypesEnum,
  url: z.string(),
});

export const SearchResultList = z.array(SearchResult).nullable();

export const GetSearchKeywordResponse = z.object({
  item: SearchResultList,
  nextPage: z.number(),
  resultCount: z.number(),
  recommendKeywords: z.array(z.string()),
});

export type SearchKeywordItemResponse = {
  content: string;
  postDate: string;
  title: string;
  type: string;
  url: string;
};

export type GetSearchKeywordResponseType = {
  item: SearchKeywordItemResponse[];
  nextPage: number;
  resultCount: number;
  recommendKeywords: string[];
};

export type GetSearchKeywordRepositoryProps = {
  keyword: string;
  typeString?: string;
  page?: number;
};
